<script>
import { defineComponent } from "vue";
import { useI18n } from "vue-i18n";

export default defineComponent({
  name: "RangeInput",
  props: {
    modelValue: {
      type: Array,
      default: () => [],
    },
    rangeSeparator: {
      type: String,
      default: "-",
    },
    startPlaceholder: {
      type: String,
    },
    endPlaceholder: {
      type: String,
    },
  },

  setup(props, context) {
    const { t } = useI18n();

    const onStartChange = (value) => {
      value = value == "-" || !isNaN(value) ? value : props.modelValue[0];

      const data = [value, props.modelValue[1]];

      context.emit("update:modelValue", data);
      context.emit("change", data);
    };
    const onEndChange = (value) => {
      value = value == "-" || !isNaN(value) ? value : props.modelValue[1];

      const data = [props.modelValue[0], value];

      context.emit("update:modelValue", data);
      context.emit("change", data);
    };

    return () => (
      <div class="input-range">
        <div class="input-range_start">
          <el-input
            class="input"
            modelValue={props.modelValue[0]}
            placeholder={props.startPlaceholder || t("commonTipStart")}
            autocomplete="off"
            onInput={onStartChange}
          />
        </div>
        <div class="input-range_separator"> {props.rangeSeparator}</div>
        <div class="input-range_end">
          <el-input
            modelValue={props.modelValue[1]}
            class="input"
            placeholder={props.endPlaceholder || t("commonTipEnd")}
            autocomplete="off"
            onInput={onEndChange}
          />
        </div>
      </div>
    );
  },
});
</script>
<style lang="scss" scoped>
.input-range {
  display: flex;
  width: 100%;
  background-color: #fff;
  background-image: none;
  border-radius: 4px;
  // border: 1px solid #dcdfe6;
  height: 32px;
  box-sizing: border-box;
  box-shadow: 0 0 0 1px var(--el-input-border-color, var(--el-border-color))
    inset;
  padding: 0 1px;
  font-size: 12px;

  // line-height: 30px;
  .input {
    border: none;
    box-sizing: border-box;
    color: #606266;
    display: inline-block;
    font-size: inherit;
    height: 32px;
    // line-height: 32px;
    outline: 0;
    border: none !important;
    transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
    width: 100%;
    :deep(.el-input__wrapper) {
      box-shadow: none;
    }
    --el-input-height: 26px;
    &::placeholder {
      color: #c0c4cc;
    }
    &::-webkit-input-placeholder {
      color: #c0c4cc;
    }
    &::-moz-placeholder {
      color: #c0c4cc;
    }
    &::-ms-input-placeholder {
      color: #c0c4cc;
    }
  }
  &_start {
    line-height: 32px;
    flex: 1 1 auto;
  }
  &_separator {
    flex: 0 0 auto;
    height: 30px;
    line-height: 30px;
  }
  &_end {
    line-height: 32px;
    flex: 1 1 auto;
  }
}
</style>
